import { API_HOST } from 'boot/helpers/env';

const LS_KEY = 'code_version';
const VERSION_ENDPOINT = '/api/code_version.php';

function joinUrl (base, path) {
    if (!base) { return path; }

    const baseNormalized = `${base}`.replace(/\/+$/u, '');
    const pathNormalized = `${path}`.replace(/^\/+/u, '');

    return `${baseNormalized}/${pathNormalized}`;
}

function extractVersion (data) {
    if (!data) { return null; }

    if (typeof data === 'string') { return data.trim() || null; }

    if (typeof data === 'object' && typeof data.version === 'string') { return data.version.trim() || null; }

    return null;
}

let dialogOpened = false;

async function openUpdateDialog ($q, serverVersion) {
    if (dialogOpened) { return; }

    if (!$q?.dialog) { return; }

    dialogOpened = true;

    const { default: CodeUpdateDialog } = await import('src/components/next/dialogs/CodeUpdateDialog.vue');

    $q.dialog({
        component: CodeUpdateDialog,
        componentProps: {
            serverVersion,
        },
    }).onOk((versionToStore) => {
        try {
            if (versionToStore) {
                localStorage.setItem(LS_KEY, versionToStore);
            }
        } catch (e) {
            // ignore
        }

        window.location.reload();
    });
}

export async function checkCodeVersionOnce ({ axios, $q }) {
    if (typeof window === 'undefined') { return; }

    if (!axios) { return; }

    if (dialogOpened) { return; }

    try {
        const versionUrl = joinUrl(API_HOST, VERSION_ENDPOINT);

        const res = await axios.get(versionUrl, {
            params: { _: Date.now() }, // анти-кеш
            headers: { 'Cache-Control': 'no-cache' },
        });

        const serverVersion = extractVersion(res?.data);

        if (!serverVersion) { return; }

        let localVersion = null;

        try {
            localVersion = localStorage.getItem(LS_KEY);
        } catch (e) {
            localVersion = null;
        }

        const normalizedLocalVersion = `${localVersion || ''}`.trim();

        // Если локально версии нет — записываем текущую и НЕ показываем диалог
        if (!normalizedLocalVersion) {
            try {
                localStorage.setItem(LS_KEY, serverVersion);
            } catch (e) {
                // ignore
            }

            return;
        }

        // Диалог показываем только если версия уже была и изменилась
        if (normalizedLocalVersion !== serverVersion) {
            await openUpdateDialog($q, serverVersion);
        }
    } catch (e) {
        // если эндпоинт недоступен — просто не мешаем пользователю
        // openUpdateDialog();
    }
}
